import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { IApplicationContext, IApplicationContextCustom } from 'shared/mf-infrastructure/types/applicationContext';

export function createApplicationContext(): IApplicationContext {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    telemetry: getTelemetry(),
    httpApi: getHttpApi(),
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
  };
}
